import {
  Component, ChangeDetectionStrategy,
  Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges,
} from '@angular/core';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'hmi-hizli-erisim',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './hizli-erisim.component.html',
  styleUrl: './hizli-erisim.component.less',
})
export class HizliErisimComponent extends FikoYTKokBilesenComponent implements OnInit, OnDestroy, OnChanges {
  @Input() girisSaati = '';
  @Input() kisiIsim = '';
  @Input() kisiSoyIsim = '';
  @Output() tikla = new EventEmitter<string>();

  girisAnimasyonu = false;
  mesaiSureYazi = '00:00:00';
  mesaiSureHaneler: string[] = ['0','0',':','0','0',':','0','0'];
  mesaiYuzde = 0;
  moladaMi = false;

  bildirimler = [
    { id: 1, saat: '23:28', mesaj: 'Vardiya başladı', yeni: false },
    { id: 2, saat: '23:30', mesaj: 'Kart okutuldu — giriş kaydedildi', yeni: true },
  ];

  private _timer: any;
  private _girisTarih: Date | null = null;
  private readonly MESAI_SURE_DK = 8 * 60;

  constructor() { super(); }

  ngOnInit() {
    this._timer = setInterval(() => {
      this._mesaiHesapla();
      this.CD.markForCheck();
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['girisSaati']) {
      this._girisiParsele();
      this._mesaiHesapla();
    }
    if ((changes['kisiIsim'] || changes['kisiSoyIsim']) && this.kisiIsim) {
      // Bildirime kişi adını ekle
      const tamIsim = `${this.kisiIsim} ${this.kisiSoyIsim}`.trim();
      const saat = new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
      this.bildirimler = [
        { id: 1, saat, mesaj: `${tamIsim} — giriş onaylandı`, yeni: true },
        { id: 2, saat, mesaj: 'Vardiya aktif — mesai başladı', yeni: false },
        { id: 3, saat, mesaj: 'Sistem hazır', yeni: false },
      ];
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    clearInterval(this._timer);
  }

  private _girisiParsele() {
    if (!this.girisSaati) { this._girisTarih = null; return; }
    const parcalar = this.girisSaati.split(':');
    if (parcalar.length < 2) { this._girisTarih = null; return; }
    const simdi = new Date();
    simdi.setHours(+parcalar[0], +parcalar[1], parcalar[2] ? +parcalar[2] : 0, 0);
    this._girisTarih = simdi;
  }

  private _mesaiHesapla() {
    if (!this._girisTarih) {
      this._mesaiSureGuncelle('00:00:00');
      this.mesaiYuzde = 0;
      return;
    }
    const farkMs = Date.now() - this._girisTarih.getTime();
    if (farkMs < 0) { this._mesaiSureGuncelle('00:00:00'); this.mesaiYuzde = 0; return; }

    const toplamSn = Math.floor(farkMs / 1000);
    const saat = Math.floor(toplamSn / 3600);
    const dk = Math.floor((toplamSn % 3600) / 60);
    const sn = toplamSn % 60;
    this._mesaiSureGuncelle(`${String(saat).padStart(2, '0')}:${String(dk).padStart(2, '0')}:${String(sn).padStart(2, '0')}`);

    const toplamDk = toplamSn / 60;
    this.mesaiYuzde = Math.min(100, Math.round((toplamDk / this.MESAI_SURE_DK) * 100));
  }

  private _mesaiSureGuncelle(yazi: string) {
    this.mesaiSureYazi = yazi;
    this.mesaiSureHaneler = yazi.split('');
  }
}
